export default __webpack_public_path__ + "static/media/min9.57c98e49.JPG";